/* Dr Mobiles — parts catalogue browser behaviour.
   Every model link is already in the HTML (crawlable). This only shows,
   hides and filters them, so the catalogue works with JS disabled too. */
(function () {
  function init(root) {
    if (root.dataset.dmPbReady === '1') return;
    root.dataset.dmPbReady = '1';

    var panels    = root.querySelectorAll('[data-dm-pb-panel]');
    var brandBtns = root.querySelectorAll('[data-dm-pb-brand]');
    var query     = root.querySelector('[data-dm-pb-query]');
    var results   = root.querySelector('[data-dm-pb-results]');
    var grid      = root.querySelector('[data-dm-pb-results-grid]');
    var count     = root.querySelector('[data-dm-pb-results-count]');
    var panelWrap = root.querySelector('[data-dm-pb-panels]');
    var allModels = Array.prototype.slice.call(root.querySelectorAll('[data-dm-pb-model]'));

    /* --- Brand tabs --- */
    brandBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-dm-pb-brand');
        brandBtns.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', String(on));
        });
        panels.forEach(function (p) {
          p.classList.toggle('dm-pb__panel--hidden', p.getAttribute('data-dm-pb-panel') !== key);
        });
      });
    });

    /* --- Device rail, scoped to its own panel --- */
    panels.forEach(function (panel) {
      var devBtns = panel.querySelectorAll('[data-dm-pb-device]');
      var groups  = panel.querySelectorAll('[data-dm-pb-group]');
      devBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-dm-pb-device');
          devBtns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          groups.forEach(function (g) {
            var show = id === 'all' || g.getAttribute('data-dm-pb-group') === id;
            g.classList.toggle('dm-pb__group--hidden', !show);
          });
        });
      });
    });

    /* --- Search across every model in the catalogue --- */
    if (!query) return;
    var timer;

    function runSearch() {
      var q = query.value.trim().toLowerCase();

      if (!q) {
        results.hidden = true;
        panelWrap.hidden = false;
        root.querySelector('.dm-pb__brands').hidden = false;
        return;
      }

      var hits = allModels.filter(function (a) {
        return a.getAttribute('data-dm-pb-model').indexOf(q) !== -1;
      }).slice(0, 60);

      grid.innerHTML = '';
      hits.forEach(function (a) { grid.appendChild(a.cloneNode(true)); });

      count.textContent = hits.length
        ? hits.length + ' model' + (hits.length === 1 ? '' : 's') + ' matching "' + query.value.trim() + '"'
        : 'No models found. Try "iPhone", "Galaxy" or "Pixel".';

      results.hidden = false;
      panelWrap.hidden = true;
      root.querySelector('.dm-pb__brands').hidden = true;
    }

    query.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(runSearch, 120);
    });
    query.addEventListener('search', runSearch);
  }

  function boot() {
    document.querySelectorAll('[data-dm-parts-browser]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
